import {
  type BrazeInAppMessagePayload,
  type BrazePushNotificationPayload,
} from '../braze.types';

export const EVENT_LISTENERS = {
  IN_APP_MESSAGE_RECEIVED: new Set<
    (messagePayload?: BrazeInAppMessagePayload) => void
  >([]),
  PUSH_NOTIFICATION_RECEIVED: new Set<
    (notificationPayload?: BrazePushNotificationPayload) => void
  >([]),
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

export function triggerInAppMessageReceivedListeners(
  messagePayload?: BrazeInAppMessagePayload,
) {
  EVENT_LISTENERS.IN_APP_MESSAGE_RECEIVED.forEach((callback) => {
    callback(messagePayload);
  });
}

export function addInAppMessageReceivedListener(callback: () => void) {
  EVENT_LISTENERS.IN_APP_MESSAGE_RECEIVED.add(callback);

  return () => {
    EVENT_LISTENERS.IN_APP_MESSAGE_RECEIVED.delete(callback);
  };
}

export function removeInAppMessageReceivedListener(callback: () => void) {
  EVENT_LISTENERS.IN_APP_MESSAGE_RECEIVED.delete(callback);
}

export function triggerPushNotificationReceivedListeners(
  notificationPayload?: BrazePushNotificationPayload,
) {
  EVENT_LISTENERS.PUSH_NOTIFICATION_RECEIVED.forEach((callback) => {
    callback(notificationPayload);
  });
}

export function addPushNotificationReceivedListener(
  callback: (notificationPayload?: BrazePushNotificationPayload) => void,
) {
  EVENT_LISTENERS.PUSH_NOTIFICATION_RECEIVED.add(callback);

  return () => {
    EVENT_LISTENERS.PUSH_NOTIFICATION_RECEIVED.delete(callback);
  };
}

export function removePushNotificationReceivedListener(
  callback: (notificationPayload?: BrazePushNotificationPayload) => void,
) {
  EVENT_LISTENERS.PUSH_NOTIFICATION_RECEIVED.delete(callback);
}
